var exports = {
  "a": "chevron__KVMR7D",
};

module.exports = exports;
